.wrapper {
  width: 100%;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    outline: none;
    border: none;
    color: #7a7670;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.051px;
    text-decoration: underline;
    background: none;
    cursor: pointer;
  }

  button:active {
    opacity: 0.5;
  }
}

// Dark mode
:global body.dark {
  :local {
    .wrapper button {
      color: #a9a49b;
    }
  }
}
